import React from 'react';
import { cn } from '../../utils/cn';
interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeader({
  title,
  subtitle,
  align = 'left',
  className
}: SectionHeaderProps) {
  return <div className={cn(align === 'center' && 'text-center', 'mb-12 md:mb-16', className)} data-id="element-70">
      <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-71">
        {title}
      </h2>
      <div className={cn('w-16 h-0.5 bg-brand-teal', align === 'center' && 'mx-auto', subtitle ? 'mb-6' : 'mb-0')} data-id="element-72" />
      {subtitle && <p className="text-xl text-brand-gray-400 max-w-2xl mt-4" data-id="element-73">{subtitle}</p>}
    </div>;
}